import { render, staticRenderFns } from "./ExpertRequests.vue?vue&type=template&id=7c522786&scoped=true&"
import script from "./ExpertRequests.vue?vue&type=script&lang=js&"
export * from "./ExpertRequests.vue?vue&type=script&lang=js&"
import style0 from "./ExpertRequests.vue?vue&type=style&index=0&id=7c522786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c522786",
  null
  
)

export default component.exports